import { canViewRequest } from 'rest/smart-card';
import { EditorCardProvider } from '@atlaskit/editor-card-provider';
import type { CardAdf, DatasourceAdf } from '@atlaskit/linking-common';
import { EditorCardProvider as EditorCardProviderDeprecated, type CardAppearance } from '@atlaskit/smart-card';
import { origin } from '@atlassian/help-center-common-util/location';
import { parseIssueKeyFromUrl } from '@atlassian/help-center-common-util/url';

const getSmartCardUrl = (issueKey: string) => {
    return `${origin()}/browse/${issueKey}`;
};

class PortalCardProviderDeprecated extends EditorCardProviderDeprecated {
    async resolve(url: string, appearance: CardAppearance): Promise<CardAdf> {
        const issueKey = parseIssueKeyFromUrl(url);
        if (issueKey === null) {
            return super.resolve(url, appearance);
        }

        return canViewRequest(issueKey).then((canViewRequestInPortal) => {
            if (canViewRequestInPortal) {
                return {
                    type: 'inlineCard',
                    attrs: {
                        url: getSmartCardUrl(issueKey),
                    },
                };
            }
            return Promise.reject();
        });
    }
}

class PortalCardProviderNew extends EditorCardProvider {
    async resolve(url: string, appearance: CardAppearance): Promise<CardAdf | DatasourceAdf<Record<string, unknown>>> {
        const issueKey = parseIssueKeyFromUrl(url);
        if (issueKey === null) {
            return super.resolve(url, appearance, false);
        }

        return canViewRequest(issueKey).then((canViewRequestInPortal) => {
            if (canViewRequestInPortal) {
                return super.resolve(getSmartCardUrl(issueKey), appearance, false);
            }
            return Promise.reject();
        });
    }
}

export { PortalCardProviderDeprecated, PortalCardProviderNew, getSmartCardUrl };
